import { apiClient } from './apiClient';

const crmService = {
  getMappings: async (entityType, entityId) => {
    const params = {};
    if (entityType) params.entity_type = entityType;
    if (entityId) params.entity_id = entityId;
    const response = await apiClient.get('/crm/', { params });
    return response.data;
  },

  createMapping: async (mappingData) => {
    const response = await apiClient.post('/crm/', mappingData);
    return response.data;
  },

  deleteMapping: async (mappingId) => {
    const response = await apiClient.delete(`/crm/${mappingId}`);
    return response.data;
  },

  getConfigs: async () => {
    const response = await apiClient.get('/crm/configs');
    return response.data;
  },

  createConfig: async (data) => {
    const response = await apiClient.post('/crm/configs', data);
    return response.data;
  },

  updateConfig: async (id, data) => {
    const response = await apiClient.patch(`/crm/configs/${id}`, data);
    return response.data;
  },

  deleteConfig: async (id) => {
    const response = await apiClient.delete(`/crm/configs/${id}`);
    return response.data;
  },

  getSindicatoMapping: async (sindicatoId) => {
    const response = await apiClient.get(`/crm/sindicato/${sindicatoId}`);
    return response.data;
  },
  linkSindicato: async (sindicatoId, externalId, provider = "clickup") => {
    const response = await apiClient.post(`/crm/sindicato/${sindicatoId}/link`, { external_id: externalId, provider });
    return response.data;
  },
  criarSindicatoSpace: async (sindicatoId, provider = "clickup") => {
    const response = await apiClient.post(`/crm/sindicato/${sindicatoId}/criar`, { provider });
    return response.data;
  },
  deleteSindicatoMapping: async (sindicatoId, mappingId) => {
    const response = await apiClient.delete(`/crm/sindicato/${sindicatoId}/${mappingId}`);
    return response.data;
  },

  getProcessoMapping: async (processoId) => {
    const response = await apiClient.get(`/crm/processo/${processoId}`);
    return response.data;
  },
  linkProcesso: async (processoId, externalId, provider = "clickup") => {
    const response = await apiClient.post(`/crm/processo/${processoId}/link`, { external_id: externalId, provider });
    return response.data;
  },
  criarProcessoList: async (processoId, provider = "clickup") => {
    const response = await apiClient.post(`/crm/processo/${processoId}/criar`, { provider });
    return response.data;
  },
  deleteProcessoMapping: async (processoId, mappingId) => {
    const response = await apiClient.delete(`/crm/processo/${processoId}/${mappingId}`);
    return response.data;
  },

  getTeamId: async () => {
    const response = await apiClient.get('/crm/team-id');
    return response.data.team_id;
  },
};

export default crmService;
